import React, { Suspense, useEffect, Component } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { empRoutes, freeRoutes, lancerRoutes, commonRoutes } from './Routes';
import AuthRoute from './Authroute';
import { WebSocketProvider } from './Utility/NewSocket';

const isChunkError = (error) => {
  if (!error) return false;
  const message = error?.message || '';
  return (
    error.name === 'ChunkLoadError' ||
    /Loading chunk|failed to load chunk/i.test(message)
  );
};

class ChunkErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    return { hasError: isChunkError(error) };
  }

  componentDidCatch(error) {
    if (!isChunkError(error)) {
      return;
    }

    console.error('Chunk loading failed. Reloading login page.', error);
    setTimeout(() => {
      window.location.href = '/login';
    }, 150);
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

const titleFromSlug = (slug) => {
  if (!slug) return 'Home | Protalz';

  const cleanSlug = slug
    .replace(/-\d+$/, '')
    .replace(/_/g, '-');

  if (cleanSlug === 'it-and-programming') {
    return 'IT & Programming | Protalz';
  }

  return `${cleanSlug
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')} | Protalz`;
};

function RouteTitleUpdater() {
  const location = useLocation();

  useEffect(() => {
    const pathParts = location.pathname.split('/').filter(Boolean);
    const slug = location.pathname.startsWith('/showcase-projects/')
      ? pathParts[1]
      : pathParts[pathParts.length - 1];

    document.title = titleFromSlug(slug);
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname,
      });
    }
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <ChunkErrorBoundary>
        <WebSocketProvider>
          <BrowserRouter basename={'/'}>
            <RouteTitleUpdater />
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                {freeRoutes.length > 0 && freeRoutes.map((item, i) => (
                  <Route key={i} path={item.name} element={item.component} />
                ))}

                {commonRoutes.map((item, i) => (
                  <Route
                    key={i}
                    path={item.name}
                    element={<AuthRoute element={item.component} user={["freelancer", "employer"]} />}
                  />
                ))}

                {empRoutes.length > 0 && empRoutes.map((item, i) => (
                  <Route key={i} path={item.name} element={<AuthRoute element={item.component} user={'employer'} />} />
                ))}

                {lancerRoutes.length > 0 && lancerRoutes.map((item, i) => (
                  <Route key={i} path={item.name} element={<AuthRoute element={item.component} user={'freelancer'} />} />
                ))}

              </Routes>
            </Suspense>

          </BrowserRouter>
        </WebSocketProvider>
      </ChunkErrorBoundary>
    </div>
  );
}

export default App;
